// extracted by mini-css-extract-plugin
module.exports = {"when":"style_when__20z9Y"};